import { render, staticRenderFns } from "./policyform.vue?vue&type=template&id=4b72d71a&"
import script from "./policyform.vue?vue&type=script&lang=js&"
export * from "./policyform.vue?vue&type=script&lang=js&"
import style0 from "./policyform.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports